import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Popup, Grid, Button, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class DeleteIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {'isOpen': false};
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
  }

  handleOpen() {
    this.setState({'isOpen': true});
  }

  handleClose() {
    this.setState({'isOpen': false});
  }

  handleDeleteClick() {
    const {order} = this.props;
    this.props.deleteDealerOrder(order);
    this.handleClose();
  }

  render() {
    const {disabled, iconName} = this.props;

    if (disabled) {
      return null;
    }

    return (
      <Popup wide inverted
        on='click'
        open={this.state.isOpen}
        onOpen={this.handleOpen}
        onClose={this.handleClose}
        trigger={<Icon link size='large' color='red' name={iconName} />}
      >
        <Grid>
          <Grid.Row>
            <Grid.Column textAlign='center'>
              <div>¿Desea eliminar la línea del pedido?</div>
              <Button secondary
                size='mini'
                content='CANCELAR'
                onClick={this.handleClose}
              />
              <Button primary
                size='mini'
                content='ELIMINAR'
                onClick={this.handleDeleteClick}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Popup>
    );
  }
}

const {deleteDealerOrder} = Actions;

export default connect(null, {deleteDealerOrder})(DeleteIcon);
